import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import {
  fiyatKurallariniListele,
  fiyatKuralOlustur,
  fiyatKuralGuncelle,
  fiyatKuralSil,
  type FiyatKuralOlusturIstegi,
  type FiyatKuralGuncelleIstegi,
  type FiyatKuralSorgusu,
  type SayfalanmisFiyatKurallari,
} from '@emanetx/sdk';
import { istemci } from '../istemci.js';

export function useFiyatKurallari(sorgu: Partial<FiyatKuralSorgusu>) {
  return useQuery<SayfalanmisFiyatKurallari>({
    queryKey: ['fiyat-kurallari', 'liste', sorgu],
    queryFn: () => fiyatKurallariniListele(istemci, sorgu),
    placeholderData: (onceki) => onceki,
  });
}

export function useFiyatKuralOlustur() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (g: FiyatKuralOlusturIstegi) => fiyatKuralOlustur(istemci, g),
    onSuccess: () => qc.invalidateQueries({ queryKey: ['fiyat-kurallari'] }),
  });
}

export function useFiyatKuralGuncelle() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: ({ id, ...g }: FiyatKuralGuncelleIstegi & { id: string }) =>
      fiyatKuralGuncelle(istemci, id, g),
    onSuccess: () => qc.invalidateQueries({ queryKey: ['fiyat-kurallari'] }),
  });
}

export function useFiyatKuralSil() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (id: string) => fiyatKuralSil(istemci, id),
    onSuccess: () => qc.invalidateQueries({ queryKey: ['fiyat-kurallari'] }),
  });
}
